import React from 'react';
import ProjectsFunctional from './components/projects-functional';
import './style.scss'

const Projects = () => {
	return <ProjectsFunctional />;
};

export default Projects;
